var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-404"},[_c('div',{staticClass:"error-404-container"},[_c('div',{staticClass:"error-404-banner"},[_c('figure',[_c('img',{attrs:{"src":require("../../public/assets/kong.webp"),"width":"260","height":"260"}})])])])])
}]

export { render, staticRenderFns }